import { useMemo } from 'react';
import { isEuEnv } from '@mb/lib';
import { useSelector } from 'react-redux';
import {
  customRendererFacets,
  customRendererFacetsIcons,
} from './renderer.config';
import { FilterListByRenderer, RendererType } from './renderer.types';

import {
  appFiltersSelector,
  mobileActiveFilterSelector,
} from '../../../redux/selectors/filtersSelector';
import { FilterData } from '../../../types';

export function useFilters(filters: FilterData[]) {
  const appFilters = useSelector(appFiltersSelector);
  const mobileActiveFilter = useSelector(mobileActiveFilterSelector);

  const currentFilter = useMemo(() => {
    return (
      filters?.find(
        (item) =>
          item.field === mobileActiveFilter?.field &&
          item.label === mobileActiveFilter?.label,
      ) ?? mobileActiveFilter
    );
  }, [filters, mobileActiveFilter]);

  const filterListByRenderer: FilterListByRenderer = useMemo(() => {
    // If it's EU environment, add all filters to default collection
    if (isEuEnv) {
      return {
        default: filters.map((filter) => ({ filterData: filter })),
        custom: [],
      };
    }

    return filters.reduce(
      (acc, filter) => {
        const isCustom = customRendererFacets.includes(filter.field);
        const key: RendererType = isCustom ? 'custom' : 'default';
        acc[key].push({
          filterData: filter,
          icon: isCustom ? customRendererFacetsIcons[filter.field] : undefined,
        });

        return acc;
      },
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      {
        default: [],
        custom: [],
      } as FilterListByRenderer,
    );
  }, [filters]);

  return {
    appFilters,
    currentFilter,
    filterListByRenderer,
    mobileActiveFilter,
  };
}
